export default __webpack_public_path__ + "static/media/quickly2.6d9ae28f.png";